import { render, staticRenderFns } from "./AppViewTasks.vue?vue&type=template&id=1cbb588a&"
import script from "./AppViewTasks.vue?vue&type=script&lang=js&"
export * from "./AppViewTasks.vue?vue&type=script&lang=js&"
import style0 from "./AppViewTasks.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports